import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Reel } from "../GameComponents/Reel";
import { Symbol } from "../GameComponents/Symbol";
import { SymbolExtended } from "./SymbolExtended";
import { Tweens } from "../Components/Effects/Tweens";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";

@engineComponent(ComponentTypes.DisplayObject)
export class ReelExtended extends Reel {
    //******************************************************************************************************************
    //  EVENTS
    //******************************************************************************************************************
    public static readonly OnSpinPostRoll: string = "onSpinPostRoll";

    //******************************************************************************************************************
    //  VARIABLES (CONFIGURE)
    //******************************************************************************************************************

    private teaseDelayTimer: number = null;

    private _teaseReel: boolean = false;

    public bonusContainer: ContainerElement = new ContainerElement();
    private bonusSymbolIndex: number = 7;

    public showSymbols(): void {
        this.shouldBeStopping = false;
        this.isStopping = false;
        this.stoppingCounter = 0;
        this.isTeasing = false;
        this.teasingSymbols = [];

        this.x = this.positionX;
        this.y = this.positionY;

        this.bonusContainer.position.x = this.x;
        this.bonusContainer.position.y = this.y;

        while (this.currentSymbols.length > 0) {
            this.returnSymbol(this.currentSymbols.pop());
        }
        for (let i = 0; i < this.symbolBottomCount + this.symbolCount + this.symbolTopCount; i++) {
            let symbolId: number;
            let symbolCase: string;

            if (i < this.symbolBottomCount) {
                symbolId =
                    this.strip[
                        (this.data.index + this.symbolBottomCount + this.symbolCount - i - 1 + this.strip.length) %
                            this.strip.length
                    ];
                symbolCase = i === this.symbolBottomCount - 1 ? Symbol.CaseRotation : Symbol.CaseBlur;
            } else if (i < this.symbolBottomCount + this.symbolCount) {
                symbolId = this.data.symbols[this.symbolBottomCount + this.symbolCount - i - 1];
                if (
                    this.data.transform &&
                    typeof this.data.transform[this.symbolBottomCount + this.symbolCount - i - 1] == "number" &&
                    this.data.transform[this.symbolBottomCount + this.symbolCount - i - 1] > -1
                ) {
                    symbolId = this.data.transform[this.symbolBottomCount + this.symbolCount - i - 1];
                }
                symbolCase = Symbol.CaseRotation;
            } else {
                symbolId =
                    this.strip[
                        (this.data.index + this.symbolBottomCount + this.symbolCount - i - 1 + this.strip.length) %
                            this.strip.length
                    ];
                symbolCase = i === this.symbolBottomCount + this.symbolCount ? Symbol.CaseRotation : Symbol.CaseBlur;
            }

            if (symbolId == 10 && symbolCase == Symbol.CaseRotation) {
                symbolCase = Symbol.CaseEmpty;
            }

            this.currentSymbols.unshift(this.getSymbol(symbolId - 1, symbolCase));

            // this.addChild(this.currentSymbols[0]);
            this.addChildAt(this.currentSymbols[0], 0);
        }

        for (let i = 0; i < this.currentSymbols.length; i++) {
            const symbol = this.currentSymbols[i];
            symbol.x = -symbol.offsetX;
            symbol.y = this.symbolHeight * (i - this.symbolTopCount) - symbol.offsetY;
        }
    }

    protected spinRoll(): void {
        this.currentSymbols.forEach((symbol, index) => {
            if (
                symbol.getCurrentCase() !== Symbol.CaseBlur &&
                symbol.getCurrentCase() !== SymbolExtended.CaseTeasingBlur &&
                symbol.getCurrentCase() !== SymbolExtended.CaseTeasingRotation
            ) {
                if (symbol.getCurrentCase() != Symbol.CaseRotation) {
                    symbol.goToCase(Symbol.CaseRotation);
                }
            }

            Tweens.removeTweens(symbol, "position");
            Tweens.positionTween(symbol, {
                tweenX: [symbol.position.x, symbol.position.x],
                tweenY: [symbol.position.y, symbol.position.y + this.symbolHeight],
                tweenDuration: this.rollSpeed,
                callbackFunction: index == this.currentSymbols.length - 1 ? this.updateReel : undefined,
                callbackScope: this,
            });
        });

        //super.spinRoll();
    }

    protected updateReel(): void {
        this.returnSymbol(this.currentSymbols.pop());

        if (this.shouldBeStopping && !this.isStopping) {
            if (this.previousReel === null) {
                this.isStopping = true;
            } else if (this.previousReel.isReelStopping()) {
                this.isStopping = true;
            }
        }

        this.stripIndex = (this.stripIndex - 1 + this.strip.length) % this.strip.length;

        let symbolId = this.strip[this.stripIndex];
        let symbolCase = Symbol.CaseBlur;

        if (this.isStopping) {
            if (this.stoppingCounter < this.symbolBottomCount) {
                symbolId =
                    this.strip[
                        (this.data.index +
                            this.symbolBottomCount +
                            this.symbolCount -
                            this.stoppingCounter -
                            1 +
                            this.strip.length) %
                            this.strip.length
                    ];
                symbolCase =
                    this.stoppingCounter === this.symbolBottomCount - 1 ? Symbol.CaseRotation : Symbol.CaseBlur;
            } else if (this.stoppingCounter < this.symbolBottomCount + this.symbolCount) {
                symbolId = this.data.symbols[this.symbolBottomCount + this.symbolCount - this.stoppingCounter - 1];
                symbolCase = Symbol.CaseRotation;
            } else {
                symbolId =
                    this.strip[
                        (this.data.index +
                            this.symbolBottomCount +
                            this.symbolCount -
                            this.stoppingCounter -
                            1 +
                            this.strip.length) %
                            this.strip.length
                    ];
                symbolCase =
                    this.stoppingCounter === this.symbolBottomCount + this.symbolCount
                        ? Symbol.CaseRotation
                        : Symbol.CaseBlur;
            }

            this.stoppingCounter++;
        }

        if (this._teaseReel) {
            symbolCase =
                this.isStopping &&
                this.stoppingCounter === this.symbolBottomCount + this.symbolCount + this.symbolTopCount
                    ? SymbolExtended.CaseTeasingRotation
                    : SymbolExtended.CaseTeasingBlur;
        }

        this.currentSymbols.unshift(this.getSymbol(symbolId - 1, symbolCase));

        // this.addChild(this.currentSymbols[0]);
        if (symbolId === this.bonusSymbolIndex) {
            this.bonusContainer.addChildAt(this.currentSymbols[0], 0);
        } else {
            this.addChildAt(this.currentSymbols[0], 0);
        }

        for (let i = 0; i < this.currentSymbols.length; i++) {
            const symbol = this.currentSymbols[i];
            symbol.x = -symbol.offsetX;
            symbol.y = this.symbolHeight * (i - this.symbolTopCount) - symbol.offsetY;
        }

        if (
            this.isStopping &&
            this.stoppingCounter === this.symbolBottomCount + this.symbolCount + this.symbolTopCount
        ) {
            this.emit(ReelExtended.OnSpinPostRoll, this.index);
            this.spinPostRoll();
        } else {
            this.spinRoll();
        }
    }

    protected spinPostRoll(): void {
        Tweens.removeTweens(this.bonusContainer, "position");
        Tweens.positionTween(this.bonusContainer, {
            tweenX: [this.positionX, this.positionX, this.positionX],
            tweenY: [this.positionY, this.positionY + this.postRoll, this.positionY],
            tweenDuration: this.postRollSpeed * 2,
        });
        super.spinPostRoll();
    }

    public setTeasing(toValue: boolean, delay: number): void {
        if (delay) {
            if (this.teaseDelayTimer) {
                clearTimeout(this.teaseDelayTimer);
            }
            this.teaseDelayTimer = setTimeout(
                function (toValue: boolean) {
                    this.isTeasing = toValue;
                }.bind(this, toValue),
                delay,
            );
        } else {
            if (this.teaseDelayTimer) {
                clearTimeout(this.teaseDelayTimer);
                this.teaseDelayTimer = null;
            }
            this.isTeasing = toValue;
        }
    }

    public setTeaseReel(toValue: boolean): void {
        this._teaseReel = toValue;
    }

    public spinStart(delay?: number): void {
        this.shouldBeStopping = false;
        this.isStopping = false;
        this.stoppingCounter = 0;
        this.isTeasing = false;
        this._teaseReel = false;
        this.teasingSymbols = [];
        this.rollSpeed = this.speed;
        this.stripIndex = (this.data.index - this.symbolTopCount + this.strip.length) % this.strip.length;

        this.alpha = 1;
        this.bonusContainer.alpha = 1;

        if (delay > 0) {
            setTimeout(() => {
                this.spinPreRoll();
            }, delay);
        } else {
            this.spinPreRoll();
        }
    }

    public hideReel(delay: number = 0): void {
        Tweens.removeTweens(this.bonusContainer, "alpha");
        Tweens.alphaTween(this.bonusContainer, {
            alphas: [1, 0],
            tweenDuration: 40,
            tweenDelay: delay,
        });

        Tweens.removeTweens(this, "alpha");
        Tweens.alphaTween(this, {
            alphas: [1, 0],
            tweenDuration: 40,
            tweenDelay: delay,
        });
    }

    public isReelTeasing(): boolean {
        return this.isTeasing;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/ReelExtended.ts
 **/